module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tabs-component"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [_vm._v("Por que trabalhar no  Moip é legal?")]), _vm._v(" "), _c('div', {
    staticClass: "tab-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('ul', {
    staticClass: "tabs-nav row"
  }, _vm._l((_vm.navItemsArray), function(menuItem) {
    return _c('li', {
      staticClass: "col-2 md-col-2 sm-col-2"
    }, [_c('button', {
      staticClass: "button",
      class: {
        active: menuItem.isActive
      },
      attrs: {
        "role": "tab",
        "aria-selected": menuItem.isActive
      },
      on: {
        "click": function($event) {
          _vm.selectItem(menuItem)
        }
      }
    }, [_c('img', {
      staticClass: "tabs-image",
      attrs: {
        "src": menuItem.image,
        "alt": menuItem.name
      }
    })])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cb9c77c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 138
// module chunks = 1